import React from 'react';
import { Accordion } from '@mui/material';

const DSAccordion = (props: React.ComponentProps<typeof Accordion>) => {
  return (
    <Accordion
      {...props}
      sx={{
        borderRadius: '0 !important',
        backgroundColor: 'transparent',
        boxShadow: 'none',
        '&:before': {
          display: 'none',
        },
        '&.Mui-expanded': {
          margin: 0,
        },
        '& .MuiAccordion-root': {
          borderRadius: '0 !important',
        },
        '& *': {
          borderRadius: '0 !important',
        },
        ...props.sx,
      }}
    />
  );
};

export default DSAccordion;
